/* eslint-disable @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface */
/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * Firest when a widget is presented to the user
 */
export interface WidgetView {}

export const widgetView = (data: Readonly<WidgetView>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'widget_view', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/widget_view/jsonschema/1-0-0',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
